import React, { useEffect, useState } from 'react'
import Plot from 'react-plotly.js';
import styles from './MileageAnalysisTab_bus.module.css';

function ModalGauge({ data }) {
    const { label, currentValue } = data
    const [stdValue, setStdValue] = useState(0)

    useEffect(() => {
        let STDvalue = 0
        if (label == "Idling") {
            STDvalue = 22
        }
        if (label == "Coasting") {
            STDvalue = 9.10
        }
        if (label == "Regeneration") {
            STDvalue = 8.72
        }
        setStdValue(STDvalue)
    }, [label])



    return (
        <div>
            {/* <div id="modalGauge_MSbus_ace" className="modal fade" role="dialog">
                <div className="modal-dialog modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title text-capitalize">{label}</h5>
                            <button type="button" className="close" data-dismiss="modal">
                                &times;
                            </button>
                        </div> */}
            <div className="modal-body p-0" style={{ overflowY: "scroll", height: "270px", }}>
                <div className="d-flex py-2">
                    <div className="col-6">
                        <div className={styles.summaryCard}>
                            <div className={`${styles.summaryCardLabel} mb-4`}>
                                Actual {label} Contribution
                            </div>
                            <div className="d-flex align-items-center justify-content-center">
                                {
                                    label == "Idling"
                                        ? <>
                                            <span className='fw-bolder' style={{ fontSize: '18px', color: currentValue <= stdValue ? '#00b050' : '#c91104' }}>
                                                {Number(currentValue)?.toFixed(2)}{"%"}
                                            </span>
                                            <span style={{ fontSize: '14px', color: '#d9a404' }}>
                                                {currentValue <= stdValue ? '▲' : '▼'}

                                            </span>
                                        </>
                                        : <>
                                            <span className='fw-bolder' style={{ fontSize: '18px', color: currentValue >= stdValue ? '#00b050' : '#c91104' }}>
                                                {Number(currentValue)?.toFixed(2)}{"%"}
                                            </span>
                                            <span style={{ fontSize: '14px', color: '#d9a404' }}>
                                                {currentValue >= stdValue ? '▲' : '▼'}

                                            </span>
                                        </>
                                }

                            </div>
                        </div>
                    </div>
                    <div className="col-6">
                        <div className={styles.summaryCard}>
                            <div className={styles.summaryCardLabel}>
                                Potential {label} Contribution Following Benchmark
                            </div>
                            <div className="d-flex align-items-center justify-content-center">
                                <span className={styles.bestValueText}>
                                    {Number(stdValue).toFixed(2)}{"%"}
                                </span>
                                <span style={{ fontSize: '14px', color: '#d9a404' }}>
                                    ▲ {/*   ▼ */}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='d-flex justify-content-center'>
                    <SolidGaugeChart label={label} value={currentValue} stdValue={stdValue} />
                </div>

            </div>
            {/* <div className="modal-footer p-2">
                <button type="button" className="btn ms_btn btn-default MS_button" data-dismiss="modal" >
                    CLOSE
                </button>
            </div> */}
            {/* </div>
                </div>
            </div> */}
        </div >

    )
}

export default ModalGauge




const SolidGaugeChart = ({ label, value, stdValue }) => {
    let barColor = label == "Idling"
        ? value <= stdValue ? 'green' : 'red'
        : value >= stdValue ? 'green' : 'red';

    const steps = [
        { range: [0, value], color: barColor },
        { range: [value, 100], color: '#e0e0e0' }
    ];

    const data = [
        {
            type: 'indicator',
            mode: 'gauge',
            value: value,
            domain: { x: [0, 1], y: [0, 1] },
            gauge: {
                axis: {
                    range: [0, 100],
                    tickvals: [0, stdValue, 100],
                    ticktext: ['0%', `${stdValue}%`, '100%'],
                    showticklabels: true,
                },
                bar: { color: barColor },
                steps: steps,
                threshold: {
                    line: { color: 'black', width: 4 },
                    thickness: 0.75,
                    value: stdValue,
                },
            }
        },
    ];

    const layout = {
        margin: { l: 40, r: 40, t: 10, b: 0 },
        width: 270,
        height: 150,
        paper_bgcolor: 'white',
        plot_bgcolor: 'white',
        annotations: [
            {
                text: `${value}%`,
                x: 0.5,
                y: 0.2, // bottom center
                xref: 'paper',
                yref: 'paper',
                showarrow: false,
                font: {
                    size: 24,
                    color: 'black',
                },
            },
        ],
    };

    return (
        <Plot
            data={data}
            layout={layout}
            config={{ displayModeBar: false }}
        />
    );
};


